// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22 2V22H2V2H22ZM16.2431 9.17154L14.8289 7.75732L12.0005 10.5858L9.17203 7.75732L7.75781 9.17154L10.5862 12L7.75781 14.8284L9.17203 16.2426L12.0005 13.4142L14.8289 16.2426L16.2431 14.8284L13.4147 12L16.2431 9.17154Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-close-rectangle-filled')
export default class CloseRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'close-rectangle-filled',
    }
  }
}
